const desktopID = 'vimeo-hero-desktop';
const mobileID = 'vimeo-hero-mobile';

const desktopContainer = document.getElementById(desktopID);
const mobileContainer = document.getElementById(mobileID);

const desktopOptions = {
	id: desktopContainer ? desktopContainer.dataset.id : null,
	autoplay: false,
	background: false,
	byline: false,
	controls: false,
	loop: true,
	muted: false,
	title: false,
	width: '100%'
};

const mobileWidth = window.innerWidth;
const mobileHeight = mobileWidth / 9 * 16;

const mobileOptions = {
	...desktopOptions,
	id: mobileContainer ? mobileContainer.dataset.id : null,
	autoplay: false,
	height: mobileHeight,
	muted: false,
	responsive: true
};

if (desktopContainer) {
	var desktopVideoPlayer = new Vimeo.Player(desktopID, desktopOptions);
}

if (mobileContainer) {
	var mobileVideoPlayer = new Vimeo.Player(mobileID, mobileOptions);
}


if (desktopVideoPlayer) {
	desktopVideoPlayer.setVolume(0.5);

	const playButton = document.querySelector('.play-button.desktop');

	playButton.addEventListener('click', function() {
		desktopVideoPlayer.play().catch(err => console.error(err));
		playButton.classList.add('hidden')
	});

	desktopVideoPlayer.on('play', function() {
		console.log('Played the first video');
	});
}

if (mobileVideoPlayer) {
	
	const playButton = document.querySelector('.play-button.mobile');

	playButton.addEventListener('click', function() {
		mobileVideoPlayer.play().catch(err => console.error(err));
	});
	
	mobileVideoPlayer.on('play', function() {
			console.log('Played the second video');
	});
}